import { IUser, IUserData } from '../user.types';
import { User } from '../user';

export const mockUsersData = (): IUserData[] => [
  {
    id: 7,
    first_name: 'Christina',
    last_name: 'Galovic',
    email: 'christina.galovic@jamesway.com'
  },
  {
    id: 4,
    first_name: 'Denis',
    last_name: 'Kan',
    email: 'denis.kan@jamesway.com'
  },
  {
    id: 8,
    first_name: 'Denisa',
    last_name: 'Lehocky',
    email: 'denisa.lehocky@jamesway.com'
  },
  {
    id: 9,
    first_name: 'Dorothy',
    last_name: 'Hanlon',
    email: 'dorothy.hanlon@jamesway.com'
  },
  {
    id: 14,
    first_name: '',
    last_name: '',
    email: 'lharris@altoleap.com'
  },
  {
    id: 5,
    first_name: 'Barb',
    last_name: 'Mitchell',
    email: 'barb.mitchell@jamesway.com'
  },
  {
    id: 6,
    first_name: 'Beth',
    last_name: 'Landry',
    email: 'beth.landry@jamesway.com'
  },
  {
    id: 3,
    first_name: 'Brandon',
    last_name: 'Puim',
    email: 'bpuim@altoleap.com'
  }
];

export const mockUsers = (data: IUserData[] = mockUsersData()): IUser[] =>
  data.map(item => new User(item));
